import { useEffect } from "react";
import { useLocalization } from "../../hooks/useLocalization";
import { getShortCode } from "../../models/Locale";
import { AvailableLocaleCodes, useLocalizationStore } from "../../stores/localizationStore";
import { localizeDayjs } from "../../utils/dayjs";
import { LocaleCode, localizeHighCharts } from "../../utils/highcharts";

export const LocalizationSetup = () => {
    const { locale, initialize, setLanguage } = useLocalization();

    const localizeApp = async () => {
        await initialize();

        // TODO: Remove `getShortCode` conversion when xola prod keys are used
        setLanguage(getShortCode(locale));
        void localizeDayjs(locale);
        void localizeHighCharts(locale as LocaleCode);
    };

    useEffect(() => {
        useLocalizationStore.setState({ locale: locale as AvailableLocaleCodes });
        void localizeApp();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locale]);

    useEffect(() => {
        if (!window.Localize) return;

        window.Localize.on("initialize", async () => {
            void localizeApp();
        });

        return () => {
            window.Localize.off("initialize");
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};
